import "./JP-Hansen-promo-1.mp4";
import "./Images";
import "./jphansen.less";
import "../../Homepage/Images/jp-poster.jpg";

const _ = require("./JP-Hansen-promo-1.mp4");